import {CommonAlertService} from './../../services/common-alert.service';
import {filter} from 'rxjs/operators';
import {MasterService} from './../../home/services/master.service';
import {Component, OnInit, Inject} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {NgForm, Form} from '@angular/forms';

@Component({
  selector: 'app-locations-modal',
  templateUrl: './locations-modal.component.html',
  styleUrls: ['./locations-modal.component.scss']
})
export class LocationsModalComponent implements OnInit {

  public regionsData: any;
  public countriesData: any;
  public countriesSelect: any;
  public regionValue: any;
  public editOb: any;
  public editData: any;
  // tslint:disable-next-line:variable-name
  public region_id: any;
  // tslint:disable-next-line:variable-name
  public country_id: any;
  public name: any;
  successMsg: any;
  public model = {
    region_id: '',
    country_id: ''
  };
  public user = {
    name: '',
  };
  public editPermission = false;

  constructor(public dialogRef: MatDialogRef<LocationsModalComponent>,
              public masterService: MasterService, @Inject(MAT_DIALOG_DATA) data, public commonAlertService: CommonAlertService) {
    if (data) {
      this.editOb = data.edit;
    }
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['more.cities.edit'] == 1) {
        this.editPermission = true;
      }
    }
    if (this.editOb) {
      const id = this.editOb.editID;
      // tslint:disable-next-line:variable-name
      const enc_id = this.editOb.encryId;

      this.masterService.getRecordById(id, enc_id, '/locations/get_data').subscribe(res => {
        // @ts-ignore
        this.editData = res.data.location;
        this.model.region_id = this.editData.region_id;
        // @ts-ignore
        this.regionsData = res.data.regions;
        this.model.country_id = this.editData.country_id;
        // @ts-ignore
        this.countriesData = res.data.countries;
        this.countriesSelect = this.countriesData;

      });
    } else {
      this.masterService.getData('/regions/get').subscribe(res => {
        // @ts-ignore
        this.regionsData = res.data;
      });

      this.masterService.getData('/countries/get').subscribe(res => {
        // @ts-ignore
        this.countriesData = res.data;
      });

    }
  }

  regionChange(args) {
    this.model.region_id = args.target.value;
    // tslint:disable-next-line:triple-equals
    this.countriesSelect = this.countriesData.filter(result => result.region_id == this.model.region_id);
  }


  submitForm(data) {

    if (this.editData) {
      // tslint:disable-next-line:max-line-length variable-name
      const form_data = Object.assign(data, { id: this.editOb.editID }, { enc_id: this.editOb.encryId }, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Updated Successfully';
      this.masterService.addEditRecord(form_data, '/locations/update').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showEdit({message: this.successMsg});
        }
      });

    } else {
      // tslint:disable-next-line:variable-name
      const form_data = Object.assign(data, { token: localStorage.getItem('token')});
      this.successMsg = 'Record Added Successfully';
      this.masterService.addEditRecord(form_data, '/locations/store').subscribe(res => {
        // @ts-ignore
        if (res.success) {
          this.commonAlertService.showSuccessMsg({message: this.successMsg});
        }
      });
    }
    this.close();
  }
  close() {
    this.dialogRef.close();
  }

}
